import {
  ChartPie,
  History,
  Left,
  Peoples,
  Trade,
  TrendTwo,
  Wallet,
} from "assets/Icon";
import { Drawer, IconButton, List, styled, useTheme } from "@mui/material";

import MenuListItem from "./Components/MenuListItem";
import secondaryLogo from "assets/logo/secondaryLogo.png";
import infoLogo from "assets/logo/infoLogo.png";
import { useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import { ROUTE_PATHS } from "routes/paths";
import { useSelector } from "react-redux";

function SideMenuDrawer({ open, onClose, drawerWidth }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const [showChildren, setShowChildren] = useState(false);

  const user = useSelector((state) => state.user?.user?.data);

  const sideMenuItems = [
    {
      key: "portfolio",
      name: "Portfolio",
      icon: <ChartPie color={theme.palette.text.main} stroke={3} />,
      path: "/portfolio",
      onClick: () => navigate("/portfolio"),
    },
    {
      key: "market",
      icon: <TrendTwo color={theme.palette.text.secondary} />,
      name: "Market",
      path: ROUTE_PATHS.market,
      onClick: () => navigate(ROUTE_PATHS.market),
    },
    {
      key: "trade",
      name: "Trade",
      icon: <Trade color={theme.palette.text.secondary} />,
      children: [
        {
          key: "basic-trade",
          name: "Basic Trade",
          path: ROUTE_PATHS.trade.basic("1", "3"),
          onClick: () => navigate(ROUTE_PATHS.trade.basic("1", "3")),
        },
        {
          key: "advanced-trade",
          name: "Advanced Trade",
          path: ROUTE_PATHS.trade.advanced("1", "3"),
          onClick: () => navigate(ROUTE_PATHS.trade.advanced("1", "3")),
        },
        {
          key: "convert-trade",
          name: "Convert Trade",
          path: "/convert",
          onClick: () => navigate("/convert"),
        },
      ],
    },
    {
      key: "wallet",
      name: "Wallet",
      icon: <Wallet color={theme.palette.text.secondary} />,
      children: [
        {
          key: "spot-wallet",
          name: "Spot Wallet",
          path: "/wallet/spot",
          onClick: () => navigate("/wallet/spot"),
        },
        {
          key: "margin-wallet",
          name: "Margin Wallet",
          path: "/wallet/margin",
          onClick: () => navigate("/wallet/margin"),
        },
        {
          key: "investment-fund",
          name: "Investment Fund",
          path: ROUTE_PATHS.wallet.investment,
          onClick: () => navigate(ROUTE_PATHS.wallet.investment),
          hide: !user?.isHaveViewInvestment
        },
      ],
    },
    {
      key: "referral",
      name: "Referral",
      icon: <Peoples color={theme.palette.text.secondary} />,
      children: [
        {
          key: "referral-page",
          name: "Referral",
          path: "/referral",
          onClick: () => navigate("/referral"),
        },
        {
          key: "referral-history",
          name: "Referral History",
          path: "/referral-history",
          onClick: () => navigate("/referral-history"),
        },
      ],
    },
    {
      key: "spot-history",
      name: "Spot History",
      icon: <History color={theme.palette.text.secondary} />,
      children: [
        {
          key: "trade-history-spot",
          name: "Trade History",
          path: "/history/trade-history?tradeTab=1&walletTypeId=1",
          onClick: () =>
            navigate("/history/trade-history?tradeTab=1&walletTypeId=1"),
        },
        {
          key: "order-history-spot",
          name: "Order History",
          path: "/history/trade-history?tradeTab=0&walletTypeId=1",
          onClick: () =>
            navigate("/history/trade-history?tradeTab=0&walletTypeId=1"),
        },
        {
          key: "deposit-history-spot",
          name: "Deposit History",
          path: "/history/spot?sideId=1",
          onClick: () => navigate("/history/spot?sideId=1"),
        },
        {
          key: "withdraw-history-spot",
          name: "Withdraw History",
          path: "/history/spot?sideId=2",
          onClick: () => navigate("/history/spot?sideId=2"),
        },
        {
          key: "transfer-history-spot",
          name: "Transfer History",
          path: ROUTE_PATHS.history.transfer,
          onClick: () => navigate(ROUTE_PATHS.history.transfer),
        },
      ],
    },
    {
      key: "margin-history",
      name: "Margin History",
      icon: <History color={theme.palette.text.secondary} />,
      children: [
        {
          key: "trade-history-margin",
          name: "Trade History",
          path: "/history/trade-history?tradeTab=1&walletTypeId=2",
          onClick: () =>
            navigate("/history/trade-history?tradeTab=1&walletTypeId=2"),
        },
        {
          key: "order-history-margin",
          name: "Order History",
          path: "/history/trade-history?tradeTab=0&walletTypeId=2",
          onClick: () =>
            navigate("/history/trade-history?tradeTab=0&walletTypeId=2"),
        },
        {
          key: "withdraw-history-margin",
          name: "Borrow",
          path: "/wallet/margin-history?typeId=2",
          onClick: () => navigate("/wallet/margin-history?typeId=2"),
        },
        {
          key: "withdraw-history-margin",
          name: "Repayment",
          path: "/wallet/margin-history?typeId=3",
          onClick: () => navigate("/wallet/margin-history?typeId=3"),
        },
        {
          key: "withdraw-history-margin",
          name: "Interest",
          path: "/wallet/margin-history?typeId=4",
          onClick: () => navigate("/wallet/margin-history?typeId=4"),
        },
      ],
    },
    {
      key: "investment-history",
      name: "Investment History",
      icon: <History color={theme.palette.text.secondary} />,
      hide: !user?.isHaveViewInvestment,
      children: [
        {
          key: "investment-history-request",
          name: "Request History",
          path: ROUTE_PATHS.history.request,
          onClick: () => navigate(ROUTE_PATHS.history.request),
        },
        {
          key: "investment-history-portfolio",
          name: "Investment History",
          path: ROUTE_PATHS.history.investment,
          onClick: () => navigate(ROUTE_PATHS.history.investment),
        },
      ],
    },
  ];

  const logoTheme = useMemo(() => {
    const logoObject = {
      primary: infoLogo,
      secondary: secondaryLogo,
      info: infoLogo,
    }
    
    return logoObject[theme.mode]
    
  },[theme])

  return (
    <DrawerStyle
      drawerWidth={drawerWidth}
      variant="persistent"
      anchor="left"
      open={open}
      keepMounted
    >
      <DrawerHeader>
        <BackIconButton onClick={onClose}>
          <Left color={theme.palette.text.main} />
        </BackIconButton>
        
        <img src={logoTheme} alt="" />
      </DrawerHeader>

      <List>
        {sideMenuItems?.map((item, index) => (
          <MenuListItem
            key={index}
            item={item}
            setShowChildren={setShowChildren}
            showChildren={showChildren}
          />
        ))}
      </List>
    </DrawerStyle>
  );
}

const DrawerStyle = styled(Drawer)(({ theme, drawerWidth, open }) => ({
  width: drawerWidth,
  zIndex: open ? "1000" : "-2",
  flexShrink: 0,

  ".MuiDrawer-paper": {
    background: theme.palette.modules.sideMenuSecondary,
    width: drawerWidth,
    boxSizing: "border-box",
    borderRight: "none",
  },
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),

  justifyContent: "center",
  minHeight: "200px",
}));

const BackIconButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(1),
  right: theme.spacing(1),
}));

export default SideMenuDrawer;
